import { render, staticRenderFns } from "./number-count.vue?vue&type=template&id=7490242f&scoped=true&"
import script from "./number-count.component.ts?vue&type=script&lang=ts&"
export * from "./number-count.component.ts?vue&type=script&lang=ts&"
import style0 from "./number-count.scss?vue&type=style&index=0&id=7490242f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490242f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7490242f')) {
      api.createRecord('7490242f', component.options)
    } else {
      api.reload('7490242f', component.options)
    }
    module.hot.accept("./number-count.vue?vue&type=template&id=7490242f&scoped=true&", function () {
      api.rerender('7490242f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/number-count/number-count.vue"
export default component.exports